import {BaseContainerModel} from '../base-container.model';

import{
    bl_applet_notification_subscription_hdr_RowClass
} from "../../dbschema"

export class AppletNotificationSubscriptionHdrModel extends BaseContainerModel {
    bl_applet_notification_subscription_hdr:  bl_applet_notification_subscription_hdr_RowClass = new bl_applet_notification_subscription_hdr_RowClass();
}